<template>
  <div class="p-1 d-flex align-items-center gap-1 flex-wrap ml-2" id="tag-container"
       style="border-top:1px solid #DCDFE9;margin-top:2px;overflow-y: auto ;max-height: 75px;min-height: 75px">
    <div v-for="item in tags" :key="item.id" @click="addOrRemoveTag(item)">
      <TagCustom :item="item" :selected="isSelected(item)" :is-button="true" />
    </div>
    <el-tag @click="$router.push('/setting#tag')" size="small" class="text-info pointer"
            style="margin: 1px">+
    </el-tag>
  </div>
</template>

<script>
import TagCustom from "../common/TagCustom";
export default {
  name: "MessageBoxTags",
  components: { TagCustom },
  props: ["conversation", "tags"],
  comments: {
  },
  methods: {
    addOrRemoveTag(tag) {
      let request = {
        conversationId: this.conversation.id,
        tagId: tag.id
      };
      this.$http.post("/api/conversation/tag", request).then(resp => {
        this.conversation.tags = resp.data.tags;
        this.$bus.$emit("tagChanged", resp.data);
      });
    },
    isSelected(tag) {
      if (this.conversation.tags != null) {
        let tags = this.conversation.tags.filter(t => t.id == tag.id);
        if (tags != null && tags.length == 1) return true;
      }
      return false;
    }
  }
};
</script>

<style scoped>
#tag-container::-webkit-scrollbar {
  display: none;
}
</style>